(() => {
  angular.module('pims')
    .directive('imageMagnify', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          const image = element[0];
          const magnifier = document.createElement('div');
          let zoom = attrs.imageMagnify ? parseFloat(attrs.imageMagnify) : 1.5; //default zoom
          let magnifierSize;

          function setMagnifierSize() {
            const smallerDimension = Math.min(image.width, image.height);
            magnifierSize = smallerDimension / 1.5;
            magnifier.style.width = magnifierSize + 'px';
            magnifier.style.height = magnifierSize + 'px';
          }

          function getRotationAngle(transform) {
            if (!transform || transform === 'none') {
              return 0;
            }
            const values = transform.split('(')[1].split(')')[0].split(',');
            const a = values[0];
            const b = values[1];
            const angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
            return angle;
          }

          function updateMagnifierBackground() {
            // Get the computed style of the image
            const computedStyle = getComputedStyle(image);
            const transform = computedStyle.transform;

            // Extract the rotation angle from the transform property
            const rotationAngle = getRotationAngle(transform);

            // Create a canvas element
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = image.width;
            canvas.height = image.height;

            // Translate to the center of the canvas before rotating
            ctx.translate(canvas.width / 2, canvas.height / 2);

            // Apply the captured rotation
            ctx.rotate(rotationAngle * Math.PI / 180);

            // Draw the image onto the canvas, adjusting for translation
            ctx.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);

            // Convert the canvas content to a data URL
            const dataURL = canvas.toDataURL();

            // Set the transformed image as the background of the magnifier
            magnifier.style.backgroundImage = `url('${dataURL}')`;
            magnifier.style.backgroundRepeat = 'no-repeat';
            magnifier.style.backgroundSize = `${image.width * zoom}px ${image.height * zoom}px`;
          }

          function imageMagnify(elem) {
            magnifier.setAttribute('class', 'img-magnifier-glass');
            elem.parentElement.insertBefore(magnifier, elem);
            setMagnifierSize();
            updateMagnifierBackground();
          }

          function moveMagnifier(event) {
            const borderWidth = 3;
            const magnifierHalfWidth = magnifier.offsetWidth / 2;
            const magnifierHalfHeight = magnifier.offsetHeight / 2;
            let cursorPosition, cursorX, cursorY;

            event.preventDefault();

            // Get the cursor's x and y positions relative to the image
            cursorPosition = getCursorPosition(event);
            cursorX = cursorPosition.x;
            cursorY = cursorPosition.y;

            // Ensure the magnifier stays within the bounds of the image
            if (cursorX > image.width - (magnifierHalfWidth / zoom)) {
              cursorX = image.width - (magnifierHalfWidth / zoom);
            }
            if (cursorX < magnifierHalfWidth / zoom) {
              cursorX = magnifierHalfWidth / zoom;
            }
            if (cursorY > image.height - (magnifierHalfHeight / zoom)) {
              cursorY = image.height - (magnifierHalfHeight / zoom);
            }
            if (cursorY < magnifierHalfHeight / zoom) {
              cursorY = magnifierHalfHeight / zoom;
            }

            // Set the position of the magnifier
            magnifier.style.left = (cursorX - magnifierHalfWidth) + "px";
            magnifier.style.top = (cursorY - magnifierHalfHeight) + "px";

            // Display what the magnifier "sees"
            magnifier.style.backgroundPosition = "-" + ((cursorX * zoom) - magnifierHalfWidth + borderWidth) + "px -" + ((cursorY * zoom) - magnifierHalfHeight + borderWidth) + "px";
          }

          function getCursorPosition(event) {
            let imageRect, cursorX = 0, cursorY = 0;
            event = event || window.event;

            // Get the x and y positions of the image
            imageRect = image.getBoundingClientRect();

            cursorX = event.pageX - imageRect.left;
            cursorY = event.pageY - imageRect.top;

            // Consider any page scrolling
            cursorX -= window.pageXOffset;
            cursorY -= window.pageYOffset;

            return { x: cursorX, y: cursorY };
          }

          function addMagnifier() {
            imageMagnify(image);
            magnifier.style.display = 'block';
            // Add the necessary event listener
            magnifier.addEventListener('mousemove', moveMagnifier);
            magnifier.addEventListener('touchmove', moveMagnifier);
            magnifier.addEventListener('click', removeMagnifier)
            image.addEventListener('mousemove', moveMagnifier);
            image.addEventListener('touchmove', moveMagnifier);
          }

          function removeMagnifier() {
            magnifier.style.display = 'none';
            removeEventListeners();
            element.off('mouseover', addMagnifier);
            if (magnifier.parentNode) {
              magnifier.parentNode.removeChild(magnifier);
            }
          }

          // Remove event listener to prevent memory leakage
          function removeEventListeners () {
            magnifier.removeEventListener('mousemove', moveMagnifier);
            magnifier.removeEventListener('touchmove', moveMagnifier);
            image.removeEventListener('mousemove', moveMagnifier);
            image.removeEventListener('touchmove', moveMagnifier);
          }

          element.on('click', addMagnifier);
          element.on('mouseover', addMagnifier);

          scope.$on('$destroy', function() {
            element.off('click', addMagnifier);
            removeEventListeners();
          });

          // Set magnifier size when image dimensions are loaded
          // To prevent cases where magnifying glass goes out of bounds
          image.onload = setMagnifierSize;
          if (image.complete) {
            setMagnifierSize();
          }
        }
      };
    });
})();
